import { carouselItems } from '@/mocks/cinema';

const tagColorMap: Record<string, string> = {
  accent: 'bg-accent-500/80 text-background-950',
  primary: 'bg-primary-500/80 text-background-950',
  secondary: 'bg-secondary-500/80 text-background-950',
};

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            精选热门剧集深度推荐，发现你的下一部心头好
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/30 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent" />
                <span
                  className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                    tagColorMap[item.tagColor] || tagColorMap.primary
                  }`}
                >
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-200 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-1">{item.subtitle}</p>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}